import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Avatar, Button, Card, CardActions, CardContent, Grid, Stack, styled, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import * as React from 'react';
import { Link } from 'react-router-dom';

const PatientCard = (props) => {

 const {
    first_name,
    second_name,
    last_name,
    city,
    address,
    gender,
    birthday,
    patient_info_id
  } = props;

  const StyledDiv = styled('div')({
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
  });
  
  return (
    <Grid  item lg={3} md={4} xs={12} sx={{position: 'relative'  }}>
        <Grid item xs={12}>
      <Avatar sx={{ m: -5, border: '6px solid #FFFFFF',zIndex:2, width: 80, height: 80 ,position: 'absolute',left:'60%'}}  />
        </Grid>
        <Grid item sx={{position: 'relative'}}>
      <Card   sx={{  pt: 8  ,boxShadow:'none',background:'#F4F4F4',height:'15rem',positiion: 'relative'}}>
        <Grid container>
        <CardContent>
        <Grid item xs={12}>
      
      <Typography    variant="caption" component="div" gutterBottom sx={{pl:'1rem'}} >
      <Stack spacing={2} >
         <StyledDiv >
         <PersonOutlineOutlinedIcon sx={{ color: !Boolean(gender) ? '#ff69b4' : '#279bff', mr: 1 }} />{' '}
          {`${first_name} ${second_name} ${last_name}`}
         </StyledDiv>
         <StyledDiv >
         <CalendarTodayOutlinedIcon sx={{ color: 'primary.main', mr: 1 }} />{' '}
          {`${dayjs(birthday).format('DD/MM/YYYY')}`}
         </StyledDiv>
         <StyledDiv  style={{flexWarp:'nowrap !important'}}>
         <LocationOnOutlinedIcon sx={{ color: 'primary.main', mr: 1 }} />{' '}
          {`${city}, ${address}`}
         </StyledDiv>
        </Stack>
        </Typography>
        </Grid>
        </CardContent>
       
            <CardActions sx={{
              width: '100%',
              padding: 0,
              position: 'absolute',
              bottom: 0
            }}    >
        <Grid item xs={12}>
          <Link to={`/patients/${patient_info_id}`} style={{textDecoration: 'none'}}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{  mb: 0, ml: 0, color: '#FFFFFF' ,boxShadow:'none',borderTopLeftRadius:0,borderTopRightRadius:0,textDecoration: 'none'}}
          >
          {Localization.translate['view_more']}
        </Button>
            </Link>
              </Grid>
              </CardActions>
        </Grid>
      </Card>
      </Grid>
</Grid>
      );
};

export default PatientCard;
